module.exports = __webpack_public_path__ + "static/media/start_for_free.3c16c04f.png";